// Header: mega panels (click, hover on desktop, Escape), burger menu, hide on scroll down.
const DESKTOP = window.matchMedia('(min-width: 100rem)')
const HOVER = window.matchMedia('(hover: hover)')

export function initHeader() {
	const header = document.querySelector('[data-header]')
	if (!header) return

	const nav = header.querySelector('[data-site-nav]')
	const burger = header.querySelector('[data-burger]')
	const toggles = [...header.querySelectorAll('[data-mega-toggle]')]

	const panelOf = (toggle) => document.getElementById(toggle.getAttribute('aria-controls'))

	const setPanel = (toggle, open) => {
		toggle.setAttribute('aria-expanded', String(open))
		panelOf(toggle)?.classList.toggle('is-open', open)
	}

	const closeAll = (except) => toggles.forEach((t) => t !== except && setPanel(t, false))

	toggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const open = toggle.getAttribute('aria-expanded') !== 'true'
			if (DESKTOP.matches) closeAll(toggle)
			setPanel(toggle, open)
		})

		// desktop with a mouse: open on hover, close shortly after leaving item and panel
		const item = toggle.closest('li')
		let timer
		item.addEventListener('mouseenter', () => {
			if (!DESKTOP.matches || !HOVER.matches) return
			clearTimeout(timer)
			closeAll(toggle)
			setPanel(toggle, true)
		})
		item.addEventListener('mouseleave', () => {
			if (!DESKTOP.matches || !HOVER.matches) return
			timer = setTimeout(() => setPanel(toggle, false), 150)
		})
	})

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') return
		const open = toggles.find((t) => t.getAttribute('aria-expanded') === 'true')
		if (open) {
			setPanel(open, false)
			open.focus()
		} else if (nav.classList.contains('is-open')) {
			setNav(false)
			burger.focus()
		}
	})

	document.addEventListener('click', (event) => {
		if (DESKTOP.matches && !header.contains(event.target)) closeAll()
	})

	// burger
	const setNav = (open) => {
		nav.classList.toggle('is-open', open)
		burger.setAttribute('aria-expanded', String(open))
		const label = open ? burger.dataset.labelClose : burger.dataset.labelOpen
		burger.querySelector('.visually-hidden').textContent = label
		document.body.classList.toggle('has-open-nav', open)
		if (!open) closeAll()
	}

	burger?.addEventListener('click', () => setNav(!nav.classList.contains('is-open')))

	DESKTOP.addEventListener('change', () => {
		setNav(false)
		closeAll()
	})

	// hide when scrolling down, show when scrolling up
	let lastY = window.scrollY
	window.addEventListener(
		'scroll',
		() => {
			const y = window.scrollY
			const menuOpen = nav.classList.contains('is-open') || toggles.some((t) => t.getAttribute('aria-expanded') === 'true')
			if (!menuOpen) header.classList.toggle('is-hidden', y > lastY && y > header.offsetHeight)
			lastY = y
		},
		{ passive: true },
	)
}
